import { ExplorerItem } from "@/types/types.ts";
import useCurrentExplorerItemId from "@/common/hooks/useCurrentExplorerItemId.ts";
import useExplorerItem from "@/common/hooks/useExplorerItem.ts";
import { useMemo } from "react";

function useCurrentExplorerItem(): ExplorerItem | null {
  const [currentExplorerItemId] = useCurrentExplorerItemId();
  const [currentExplorerItem] = useExplorerItem(currentExplorerItemId || '');

  return useMemo(() => {
    return currentExplorerItem;
  }, [currentExplorerItem]);
}

export default useCurrentExplorerItem;

/*function useCurrentExplorerItem(): ExplorerItem | null {
  const [currentExplorerItemId] = useCurrentExplorerItemId()
  const [currentExplorerItem] = useExplorerItem(currentExplorerItemId || '')

  return currentExplorerItem;
}

export default useCurrentExplorerItem*/
